import { ILab, ILabSourceUploadContext } from '@interacta/util-i-lab';
import { createAction, props } from '@ngrx/store';
import {
    ILabPostDocumentEvent,
    ILabPostLightBoxEvent,
} from '../models/i-lab-post-view.model';

export const createPostFromLabContents = createAction(
    '[i-Lab] Create Post From Lab Contents',
    props<{ contentIds: number[]; labId: ILab['id'] }>(),
);

export const openILabAddSourceTypeDialog = createAction(
    '[i-Lab] Open ILab Add Source Type Dialog',
    props<{ context: ILabSourceUploadContext }>(),
);

export const openILabSourceRecorder = createAction(
    '[i-Lab] Open ILab Source Recorder',
    props<{ context: ILabSourceUploadContext }>(),
);

export const openILabSourceUpload = createAction(
    '[i-Lab] Open ILab Source Upload',
    props<{ context: ILabSourceUploadContext }>(),
);

export const openILabSourcePost = createAction(
    '[i-Lab] Open ILab Source Post',
    props<{ context: ILabSourceUploadContext }>(),
);

export const openILabSourceFreeText = createAction(
    '[i-Lab] Open ILab Source Free Text',
    props<{ context: ILabSourceUploadContext }>(),
);

export const reopenILabAddSourceTypeDialog = createAction(
    '[i-Lab] Reopen ILab Add Source Type Dialog',
);

export const creditLimitExceededError = createAction(
    '[i-Lab] Credit Limit Exceeded Error',
);

export const openILabPostLightbox = createAction(
    '[i-Lab] Open ILab Post Lightbox',
    props<ILabPostLightBoxEvent>(),
);

export const openILabPostPreview = createAction(
    '[i-Lab] Open ILab Post Preview',
    props<{ postId: number }>(),
);

export const openILabPostDocument = createAction(
    '[i-Lab] Open ILab Post Document',
    props<ILabPostDocumentEvent>(),
);
